import axios, {AxiosRequestConfig, AxiosResponse} from 'axios';

export class ApiRequests {
  static async executeRequest(requestObject: AxiosRequestConfig): Promise<any> {
    return await axios.request(requestObject).then((result: AxiosResponse<any>) => {
      return result.data
    }).catch((reason: any) => {
      console.error(reason, '\n*******', requestObject)
      throw Error(`Error Executing Request : ${reason.response.data.description}`);
    });
  }
}
